<ng-template #helpTooltip>
  <div class="header">{{ summary }}</div>
  <div class="content">{{ description }}</div>
  <ng-content></ng-content>
</ng-template>

<button
  class="btn btn-sm btn-icon-only help-icon"
  [tooltip]="helpTooltip"
  [placement]="placement"
  [adaptivePosition]="placement !== 'auto'"
  triggers=""
  #help="bs-tooltip"
  placement="top"
  type="button"
  container="body"
  containerClass="tmx-inline-help-tooltip"
  (click)="toggle(help)"
  (blur)="help.hide(); isFocused = false"
>
  <i class="modus-icons notranslate" aria-hidden="true">help</i>
</button>
